import React from "react";
import "../styles/ReturnsAndVolumeModalSection.scss";

function ReturnsAndVolumeModalSection(props) {
  // const percentColor = (color) => {
  //   return color === null ? "percent grey" : color ? "percent red" : "percent green";
  // };

  const percentColorVolume = (value) => {
    return value === true ? "percent red" : "percent green";
  };

  return props.title === "PRICE RETURNS" ? (
    <div
      className="returns-volume"
      style={{
        background:
          props.chartDisplay === props.title + "-Chart" ? "#171717" : null,
        cursor: "pointer",
      }}
      onClick={() => props.setChartDisplay(props.title + "-Chart")}
    >
      <div className="title">{props.title}</div>
      <div>
        <div className="row">
          <div className="grey" style={{ color: "#BBB8B8" }}>
            1D / %Chg
          </div>
          <div
            className={
              props.original.current_trr_1d
                ? parseFloat(props.original.current_trr_1d).toFixed(2) > 0
                  ? "percent green"
                  : parseFloat(props.original.current_trr_1d)
                      .toFixed(2)
                      .includes("-")
                  ? "percent red"
                  : "percent gray"
                : "percent gray"
            }
          >
            {props.original.current_trr_1d
              ? parseFloat(props.original.current_trr_1d.slice(0, -1)).toFixed(
                  2,
                ) + "%"
              : "- - -"}
          </div>
        </div>
        <div className="row">
          <div className="grey" style={{ color: "#BBB8B8" }}>
            1W / %Chg
          </div>
          <div
            className={
              props.original.current_trr_5d
                ? parseFloat(props.original.current_trr_5d).toFixed(2) > 0
                  ? "percent green"
                  : parseFloat(props.original.current_trr_5d)
                      .toFixed(2)
                      .includes("-")
                  ? "percent red"
                  : "percent gray"
                : "percent gray"
            }
          >
            {props.original.current_trr_5d
              ? parseFloat(props.original.current_trr_5d.slice(0, -1)).toFixed(
                  2,
                ) + "%"
              : "- - -"}
          </div>
        </div>
        <div className="row">
          <div className="grey" style={{ color: "#BBB8B8" }}>
            1M / %Chg
          </div>
          <div
            className={
              props.original.current_trr_1mo
                ? parseFloat(props.original.current_trr_1mo).toFixed(2) > 0
                  ? "percent green"
                  : parseFloat(props.original.current_trr_1mo)
                      .toFixed(2)
                      .includes("-")
                  ? "percent red"
                  : "percent gray"
                : "percent gray"
            }
          >
            {props.original.current_trr_1mo
              ? parseFloat(props.original.current_trr_1mo.slice(0, -1)).toFixed(
                  2,
                ) + "%"
              : "- - -"}
          </div>
        </div>
        <div className="row">
          <div className="grey" style={{ color: "#BBB8B8" }}>
            3M / %Chg
          </div>
          <div
            className={
              props.original.current_trr_3mo
                ? props.original.current_trr_3mo.toFixed(2) > 0
                  ? "percent green"
                  : props.original.current_trr_3mo.toFixed(2) < 0
                  ? "percent red"
                  : "percent gray"
                : "percent gray"
            }
          >
            {props.original.current_trr_3mo
              ? props.original.current_trr_3mo.toFixed(2) + "%"
              : "- - -"}
          </div>
        </div>
        <div className="row">
          <div className="grey" style={{ color: "#BBB8B8" }}>
            Y/Y Qtrly Avg
          </div>
          <div
            className={
              props.original.current_trr_ytd
                ? parseFloat(props.original.current_trr_ytd).toFixed(2) > 0
                  ? "percent green"
                  : parseFloat(props.original.current_trr_ytd)
                      .toFixed(2)
                      .includes("-")
                  ? "percent red"
                  : "percent gray"
                : "percent gray"
            }
          >
            {props.original.current_trr_ytd
              ? parseFloat(props.original.current_trr_ytd.slice(0, -1)).toFixed(
                  2,
                ) + "%"
              : "- - -"}
          </div>
        </div>
        {/* {props.original.current_trr_ytd && (
          <div className='row'>
            <div className='grey'>Y/Y Qtrly Avg</div>
            <div className={percentColor(props.original.red_current_trr_ytd)}>
              {parseFloat(props.original.current_trr_ytd.slice(0, -1)).toFixed(2)}%
            </div>
          </div>
        )} */}
      </div>
    </div>
  ) : (
    <div
      className="returns-volume"
      style={{
        background:
          props.chartDisplay === props.title + "-Chart" ? "#171717" : null,
        cursor: "pointer",
      }}
      onClick={() => props.setChartDisplay(props.title + "-Chart")}
    >
      <div className="title">{props.title}</div>
      <div>
        <div className="row">
          <div className="grey" style={{ color: "#BBB8B8" }}>
            1D / %Chg
          </div>
          <div
            className={
              props.original.calc_volume_1d
                ? percentColorVolume(props.original.red_calc_volume_1d)
                : "percent grey"
            }
          >
            {props.original.calc_volume_1d &&
            props.original.calc_volume_1d !== "NaN%"
              ? props.original.calc_volume_1d
              : "- - -"}
          </div>
        </div>
        <div className="row">
          <div className="grey" style={{ color: "#BBB8B8" }}>
            1W / %Chg
          </div>
          <div
            className={
              props.original.calc_volume_5d
                ? percentColorVolume(props.original.red_calc_volume_5d)
                : "percent grey"
            }
          >
            {props.original.calc_volume_5d &&
            props.original.calc_volume_5d !== "NaN%"
              ? props.original.calc_volume_5d
              : "- - -"}
          </div>
        </div>
        <div className="row">
          <div className="grey" style={{ color: "#BBB8B8" }}>
            1M / %Chg
          </div>
          <div
            className={
              props.original.calc_volume_1m
                ? percentColorVolume(props.original.red_calc_volume_1m)
                : "percent grey"
            }
          >
            {props.original.calc_volume_1m &&
            props.original.calc_volume_1m !== "NaN%"
              ? props.original.calc_volume_1m
              : "- - -"}
          </div>
        </div>
        <div className="row">
          <div className="grey" style={{ color: "#BBB8B8" }}>
            3M / %Chg
          </div>
          <div
            className={
              props.original.calc_volume_3m
                ? percentColorVolume(props.original.red_calc_volume_3m)
                : "percent grey"
            }
          >
            {props.original.calc_volume_3m &&
            props.original.calc_volume_3m !== "NaN%"
              ? props.original.calc_volume_3m
              : "- - -"}
          </div>
        </div>
      </div>
    </div>
  );
}
export default React.memo(ReturnsAndVolumeModalSection);
